import React from "react";
import { Redirect, useHistory } from "react-router-dom";
import { BenefitDetail } from "../../components/BenefitDetail";
import { getOAIBenefitDetails } from "../../components/customBenefits/OAI/getOAIBenefitDetails";
import { getPGLIBenefitDetails } from "../../components/customBenefits/PGLI/getPGLIBenefitDetails";
import { BENEFITS_BY_SLUG } from "../../data";
import {
  PATH_BENEFITS_PERKS,
  routeHelpersBenefitDetail,
  routeHelpersBenefitsSectionTab
} from "../../paths";
import { OAI_KEY, PGLI_KEY } from "../../utils/constants";
import { BenefitsInsurancePage } from "../BenefitsInsurancePage";

export const RouteBenefitDetail: React.FC = () => {
  const { params, state } = routeHelpersBenefitDetail.useData();
  const history = useHistory();

  const benefit = BENEFITS_BY_SLUG[params.slug];

  const backPath =
    state.backPath ||
    (routeHelpersBenefitsSectionTab.createLocationObject({
      section: "insurance",
      tab: "all"
    }).pathname as string);

  if (!benefit) {
    return <Redirect to={PATH_BENEFITS_PERKS} />;
  }

  // The Wingspan master-policy plans have their own detail page: it carries
  // regional eligibility and the enrollment/cancellation state machine rather
  // than catalog content.
  if (params.slug === OAI_KEY || params.slug === PGLI_KEY) {
    return (
      <BenefitsInsurancePage
        parentPath={backPath}
        planType={params.slug}
        insurance={
          params.slug === OAI_KEY
            ? getOAIBenefitDetails()
            : getPGLIBenefitDetails()
        }
      />
    );
  }

  return (
    <BenefitDetail benefit={benefit} onBack={() => history.push(backPath)} />
  );
};
